import { RbacUser } from "../../../shared/interfaces/rbac/user.interface";

export class AuthModel {
  authToken: string;
  refreshToken: string;
  expiresIn: Date;

  setAuth(auth: AuthModel) {
    this.authToken = auth.authToken;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
  }
}

export interface IToken {
  tokenType: string;
  accessToken: string;
  refreshToken: string;
}

export interface DecodedToken {
  nameidentifier: string;
  Scheme: string;
  Scopes: string[];
  Apps: string[];
  UserName: string;
  IsGlobalAdmin: string;
  UserApplicationId: string;
  ConsortiumId: string;
  exp: number;
  iss: string;
  aud: string;
  permissions: string[];
  details: RbacUser;
}
